import { Table } from 'antd'
import { AnyObject } from 'antd/es/_util/type';
import Column from 'antd/es/table/Column';
import React from 'react'
import { AgencyPageStyle } from '../../Pages/agencies/agencyPageStyle';
import { GetColumnData } from '../../Pages/agencies/getColumns';
import { useAgencyInfo } from '../../Context/agencyContext';
import { AgencyDashboardData } from '../../Models/tableDetailsModel';

interface TableColumn {
    title: string;
    dataIndex: string;
    key: string;
    align?: 'left' | 'center' | 'right';
    width?: string;
    fixed?: 'left' | 'right' | boolean
    sorter?: boolean
}

export const AllAgencyTable = () => {
    const { allAgencyData } = useAgencyInfo()

    const { tableCellwithBorder, tableCellwithoutBorder } = AgencyPageStyle().classes

    const GetValueWithSign = (title: string, value: string) => {
        return (title?.includes('%') ? value + "%" : title?.includes('$') ? '$' + value : value)
    }

    if(!allAgencyData){
        return null;
    }

    const columns = GetColumnData(allAgencyData) ?? []
    const data = allAgencyData?.agencyDashboardDataResp || []
    const lastRow = data[data.length - 1]
    const dataWithoutLast = data.slice(0, -1)

    return (
        <Table<AgencyDashboardData>
            dataSource={dataWithoutLast}
            size='middle'
            bordered
            sticky
            pagination={false}
            scroll={{ y: 'calc(100vh - 355px)', x: 'max-content' }}
            style={{ width: '100%' }}
            summary={() => {
                return (
                    <Table.Summary fixed>
                        <Table.Summary.Row>
                            {columns.map((column, index) => (
                                <Table.Summary.Cell
                                    key={column.key}
                                    index={index}
                                    align={column.align}
                                    className={column.title === "TYPE" ? tableCellwithBorder : tableCellwithoutBorder}
                                >
                                    {GetValueWithSign(
                                        column.title as string,
                                        // @ts-ignore
                                        lastRow?.[column.dataIndex as keyof AgencyDashboardData] as string
                                    )}
                                </Table.Summary.Cell>
                            ))}
                        </Table.Summary.Row>
                    </Table.Summary>
                )
            }}
        >
            {/* @ts-ignore */}
            {columns.map((column: TableColumn) => (
                <Column
                    key={column.key}
                    title={column.title}
                    dataIndex={column.dataIndex}
                    align={column.align}
                    width={column.width}
                    fixed={column.fixed}
                    sorter={column.sorter}
                    className={column.title === "TYPE" ? tableCellwithBorder : tableCellwithoutBorder}
                    render={(data: string) => (
                        <>{GetValueWithSign(column.title, data)}</>
                    )}
                />
            ))}
        </Table>
    )
}
